import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 7v14","key":"svg-0"}],["path",{"d":"M9 18l3 3l3 -3","key":"svg-1"}],["path",{"d":"M14 3v4h-4v-4l4 0","key":"svg-2"}]]

const IconArrowDownSquare = createReactComponent('outline', 'arrow-down-square', 'ArrowDownSquare', __iconNode);

export default IconArrowDownSquare;